import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {
  ContactSelfServiceFormsService,
  ISharedSettings,
} from '../contact-self-service-forms.service';
import { take } from 'rxjs/operators';
import { Title } from '@angular/platform-browser';
@Component({
  selector: 'app-self-service-acknowlagement-screen',
  templateUrl: './self-service-acknowlagement-screen.component.html',
  styleUrls: ['./self-service-acknowlagement-screen.component.scss'],
})
export class SelfServiceAcknowlagementScreenComponent implements OnInit {
  settings: ISharedSettings;
  constructor(
    private router: Router,
    private contactSelfService: ContactSelfServiceFormsService,
    private titleService: Title
  ) {}

  ngOnInit(): void {
    this.titleService.setTitle('Contact self-service');
    this.contactSelfService.currentsharedFormSettings
      .pipe(take(1))
      .subscribe((sharedSettings: ISharedSettings) => {
        this.settings = { ...sharedSettings };
      });
  }

  tryAgain(): void {
    this.router.navigate([
      './contact-form',
      'landing',
      this.settings.contactType,
    ]);
  }
}
